module.exports = __webpack_public_path__ + "static/rimac-automobili-bw-dcaca61b07798dd5ecd6c77409600937.jpg";